import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'bom-info-icon',
  templateUrl: './info-icon.component.html',
  styleUrls: ['./info-icon.component.scss'],
})
export class InfoIconComponent {
  @ViewChild('infoIcon', { static: true }) infoIconElement: ElementRef;

  @Output()
  invokedEvent = new EventEmitter<any>();

  @Input()
  content$: string | Observable<string>;

  @Input()
  linkBeforeIcon: string;

  @Input()
  linkAfterIcon: string;

  private firstInvoke = true;

  intialInvoke() {
    if (this.firstInvoke) {
      this.invokedEvent.emit();
      this.firstInvoke = false;
    }
  }
}
